import React from 'react'
import './index.scss'
import CatalogTransferTypeBox from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferTypeBox'
import CatalogTransferWizardHeader from '../CatalogTransferWizard/CatalogTransferWizardHeader'

interface CatalogTransferTypeSelectionProps {
    onClick: (type: 'acquiring' | 'relinquishing') => void
}

const CatalogTransferTypeSelection = ({ onClick }: CatalogTransferTypeSelectionProps) => (
    <div className="catalog-transfer-type-selection">
        <CatalogTransferWizardHeader title="Catalog Action">
            <p>
                Click <strong>Acquiring</strong> below to confirm that you are adding works to your catalog.
            </p>
        </CatalogTransferWizardHeader>
        <div className="ct-transfer-types">
            <CatalogTransferTypeBox
                icon="add"
                heading="Acquiring"
                className="ct-acquire"
                onClick={() => onClick('acquiring')}
            >
                <div>
                    <p>
                        I want to submit a request to transfer rights to works that are currently registered by another
                        Member from their Catalog to my Catalog.
                    </p>
                    <ul>
                        <li>I am acquiring these rights from the other Member </li>
                        <li>I believe that Member is prepared to relinquish their rights so I can acquire them.</li>
                        <li>I know the other Member's Publisher Name, Publisher IPI or MLC Publisher Number</li>
                    </ul>
                </div>
            </CatalogTransferTypeBox>
            <CatalogTransferTypeBox
                icon="close"
                heading="Relinquishing"
                className="ct-relinquish"
                onClick={() => onClick('relinquishing')}
            >
                <div>
                    <p>I want to transfer rights to work/shares out of my catalog.</p>
                    <ul>
                        <li>Transfer ownership of existing works</li>
                        <li>Move rights out of your catalog</li>
                        <li>Select from your current holdings</li>
                    </ul>
                </div>
            </CatalogTransferTypeBox>
        </div>
    </div>
)

export default CatalogTransferTypeSelection
